export default __webpack_public_path__ + "static/media/techblog4table1.8a80aa31.png";